import { styledWithTheme } from "../../context";
import { A11Y_INLINE_MIN_SIZE, px } from "../../utils";
import { RadioColorScheme } from "../";
import { DEFAULT_RING_SIZE } from "../constants";
import { getBorderColor } from "../utils";
var Ring = styledWithTheme('div')(function (_ref) {
  var selectors = _ref.theme.selectors,
      colorScheme = _ref.colorScheme,
      disabled = _ref.disabled,
      error = _ref.error;
  var isInverted = colorScheme === RadioColorScheme.Inverted;

  var getColor = function getColor(color) {
    return color === 'transparent' ? color : selectors.color(color);
  };

  var getColorParams = {
    disabled: disabled,
    error: error,
    getColor: getColor,
    isInverted: isInverted
  };
  var borderColor = getBorderColor(getColorParams);
  return {
    width: px(A11Y_INLINE_MIN_SIZE),
    height: px(A11Y_INLINE_MIN_SIZE),
    boxSizing: 'border-box',
    borderRadius: '1000px',
    border: "".concat(px(DEFAULT_RING_SIZE), " solid ").concat(borderColor),
    transition: 'all 0.2s',
    position: 'absolute',
    top: px(selectors.space('S300')),
    right: px(selectors.space('S300'))
  };
});
export default Ring;